import { useEffect, useState } from 'react';
import { Button, Card, Chip, IconButton, Popover, Select, Typography } from '@panviva/panviva-react-ui';
import React from 'react';
import './gridStyles.scss';

export const AsyncDropDownColumnMenu = (props: any) => {
    const { title, field, value, menuOptions, asyncloader, onFilterApply, onClear } = props;
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState<readonly any[]>([]);
    const [filteredOptions, setFilteredOptions] = useState<any>([]);
    const [selectedValue, setSelectedValue] = React.useState(value || []);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const loading = open && options.length === 0;
    const [openPopper, setOpenPopper] = useState(false);
    const id = open ? 'popper-async-dropdown' : undefined;
    const [chips, setChips] = useState<any>(null);

    useEffect(()=>{
        setOpenPopper(Boolean(anchorEl))
    },[anchorEl])

    useEffect(()=>{
        setFilteredOptions(options || []);
      }, [options])

    useEffect(()=>{
        const chips = selectedValue.map((item:any) => <Chip className="select-menu-chips" label={item} action actionIcon="cancel" onAction={() => onChipRemove(item)} />);
        setChips(chips);
    }, [selectedValue])

    const onChipRemove = (value:string) =>{
        setSelectedValue(selectedValue?.filter((item:any) => item !== value));
    }

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget?.parentElement);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            if(menuOptions?.length){
                setOptions(menuOptions);
            }else{
                await asyncloader().then((data: any) => {
                if (active) {
                    setOptions(data || []);
                    }
                });
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    const onOptionsChange = (event:any) => {
        const selectedIndex = selectedValue.findIndex(
          (item: any) => item === event.target.value
      );
      let newSelected: any[] = [];
    
      if (selectedIndex === -1) {
          newSelected = newSelected.concat(selectedValue, event.target.value);
      } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selectedValue.slice(1));
      } else if (selectedIndex === selectedValue.length - 1) {
          newSelected = newSelected.concat(selectedValue.slice(0, -1));
      } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selectedValue.slice(0, selectedIndex),
            selectedValue.slice(selectedIndex + 1)
          );
      }
      setSelectedValue(newSelected);
    }

    const onButtonClick = (buttonName: string) => {
        if (buttonName === 'apply' && selectedValue?.length > 0) {
            onFilterApply(field, selectedValue, "in");
        } else {
            onClear(field);
            setSelectedValue([]);
        }
        setAnchorEl(null);
        setFilteredOptions(options || []);
    };

    return (
        <>
            <IconButton icon={value ? "filter-active" : "filter-inactive"} onClick={handleClick}/>

            <Popover id={id} open={openPopper} anchorEl={anchorEl} onClose={() => handleClose()} anchorOrigin={{vertical:'bottom', horizontal:'left'}}>
                <Card style={{ display: 'flex' }}>
                    <Typography
                        style={{ marginBottom: '10%', fontWeight: 'bold' }}
                        variant="body_2"
                    >
                        {title}
                    </Typography>                  

                <Select
                    loading={loading}
                    multiple
                    closeOnSelect={false}
                    selected={selectedValue}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    chips={chips}
                    style={{width:"240px"}}>    
                {
                    filteredOptions?.map((option:string)=>{
                    return <div key={option} className='filter-menu-item'>
                        <input
                        id={option}
                        type="checkbox"
                        value={option} 
                        checked={selectedValue?.includes(option)} onChange={onOptionsChange}/>&nbsp;
                        <label className='filter-menu-label' htmlFor={option} title={option}>{option}</label>
                    </div>
                    })
                }
                </Select>

                    <div className='filter-button'>
                        <Button variant='text' onClick={() => onButtonClick('clear')}>clear</Button>&nbsp;
                        <Button variant='text' onClick={() => onButtonClick('apply')}>apply</Button>
                    </div>
                </Card>
            </Popover>
        </>
    );
};
